import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, thriweMarketPlaceUaeUrl, thriweMarketPlaceUrl } from '../../../../Containers/Config';
import { Constant } from '../../../../Containers/Helpers/constant';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { DOWNLOAD_REFERRALS, DOWNLOAD_REFERRALS_ERROR, DOWNLOAD_REFERRALS_SUCCESS } from '../../actionType';

function* getDownloadReferrals({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${thriweMarketPlaceUrl}/v1/client/admin/download-referrals`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: DOWNLOAD_REFERRALS_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: DOWNLOAD_REFERRALS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: DOWNLOAD_REFERRALS_ERROR, payload: error });
  }
}

export function* watchGetDownloadReferrals() {
  yield takeEvery(DOWNLOAD_REFERRALS, getDownloadReferrals);
}

function* getDownloadReferralsSaga() {
  yield all([fork(watchGetDownloadReferrals)]);
}

export default getDownloadReferralsSaga;
